<div class="app-wrapper top-bar mt-0">
    <main>
        <div class="container-fluid px-2 px-md-4 px-lg-5 py-4 py-xl-5">
            <div class="content-container m-0">
                <div class="d-flex py-4">
                    <div class="login-form mx-auto">
                        <div class="d-flex mb-3 flex-column">
                            <img class="logo p-4" src="/assets/logo-large.svg" alt="MacDonnell Council" />
                        </div>

                        @if (!token) {
                            <h1 class="h4 mb-3">Missing token</h1>
                            <p>This page expects a reset token. Please use the link from your reset email.</p>
                            <p class="my-0 small"><a routerLink="/forgot-password">Request a new reset link</a></p>
                        }
                        @if (token && !success) {
                            <form (ngSubmit)="doReset()" #resetForm="ngForm">
                                <h1 class="h4 mb-3">Set a new password</h1>
                                @if (error) {
                                    <div class="alert alert-danger" role="alert">{{ error }}</div>
                                }
                                <div class="form-group">
                                    <label for="new_pass">New password</label>
                                    <input
                                        class="form-control"
                                        type="password"
                                        id="new_pass"
                                        name="first"
                                        required
                                        minlength="8"
                                        [(ngModel)]="form.first"
                                        autocomplete="new-password"
                                    />
                                </div>
                                <div class="form-group">
                                    <label for="new_pass_confirm">Confirm new password</label>
                                    <input
                                        class="form-control"
                                        type="password"
                                        id="new_pass_confirm"
                                        name="second"
                                        required
                                        minlength="8"
                                        [(ngModel)]="form.second"
                                        autocomplete="new-password"
                                    />
                                </div>
                                @if (form.first && form.second && !passwordsMatch()) {
                                    <div class="alert alert-warning small" role="alert">Passwords don't match.</div>
                                }
                                <div class="d-flex">
                                    <input
                                        type="submit"
                                        value="Set password"
                                        class="btn btn-primary ms-0 mb-4"
                                        [disabled]="!resetForm.form.valid || !passwordsMatch() || loading"
                                    />
                                </div>
                                <p class="my-0 small"><a routerLink="/login">Back to sign in</a></p>
                            </form>
                        }
                        @if (success) {
                            <h1 class="h4 mb-3">Password updated</h1>
                            <p>Your password has been changed. Redirecting you to sign in&hellip;</p>
                        }
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>
